module.exports = __webpack_public_path__ + "media/B-A-005_SAF_BTB_WorkingFromHome_v3.9e53ba58.mp4";